import Rest from '../../services/rest';
import { IUploaderFileResponse } from '../../types/components/uploader';

export const getFileLink = (id: string, idOwner: string) => {
    const apiUrl = `${(new URL(window.location.href)).origin}/api`;
    const url = new URL(`${apiUrl}/files-service/get`);
    url.searchParams.append('api', apiUrl);
    url.searchParams.append('id', id);
    url.searchParams.append('idOwner', idOwner);
    url.searchParams.append('token', Rest.getToken());
    return url.toString();
};

export const getFileName = (item: IUploaderFileResponse) => item.name.replace(/\[.*?\]-/, '');
